import apiCall from "../AuthorizedApi";
import { getHostUrl } from "../getHostUrl";

export const updateFCMTokenAPI = async (fcmToken: string) => {
  try {
    const response = await apiCall({
      method: "POST",
      url: `${getHostUrl()}/account/fcm-token/`,
      data: {
        Fcm_token: fcmToken,
      },
    });
    return response;
  } catch (error: any) {
    throw error;
  }
};

